var GraphicNote = require('./graphic'),
    SignatureShapeView = require('../../../../../../canvas/views/shape/signature/signature'),
    BaseSVGNote = require('./base'),
    SignatureShapeModel = require('../../../../../../canvas/models/signature');


/**
 * This should probably extend BaseSVGNote and mix-in GraphicNote properties as applicable
 * instVars
 * - bottomTextModel
 */


module.exports = GraphicNote.extend({

    SUPPORTS_COLOR_PICKER: 0,

    ShapeModel: SignatureShapeModel,
    ViewConstructor: require('../../../../../views/note/signature/signature'),
    init: 'X',
    desc: "Signature",
    createHotKey: 's',
    actionTitle: 'Sign',
    iconClass: 'icm-quill',
    defaultSubType: 'signature',
    getNoteClass: BaseSVGNote.prototype.getNoteClass,

    defaultShapeColor: '#000000',

    defaultSVGAttrsEdit: function( color ) {

        return {
            fill: color ? color : this.getDefaultShapeColor()
        };

    },

    shapeView: function(options) {
        return new SignatureShapeView(options);
    },
    /* SHOULD ALWAYS RETURN array of ONE SHAPE */
    shapeModelsToRender: function(page) {
        //if bottom text: return 2 GRAPHIC NOTE shapes, otherwise one shape
        var shapes = BaseSVGNote.prototype.shapeModelsToRender.apply(this, arguments);

        //store the bottom text on the signature shape model
        var bottomTextShape = _.find(shapes, function(s) {
            return s.origSVGAttrs['shape-type'] === 'bottomText';
        });

        // want to know the bottom text but not yet part of shape
        // it's rendered after where the original should from the model

        if ( !bottomTextShape )
            return shapes;

        //now doing first but prob best in render ... also the raphael el
        // store the bottom shape as a property on this model
        var aSigShape = _.without(shapes, bottomTextShape)[0];
        this['bottomTextModel'] = bottomTextShape; /* store it on the model -- if there will be check to render on render on the shape*/ //todo: no longer necessary (?)
        return [aSigShape];

    }

});





/*

 // Make signature but incorp in here --

 this['INITIALS'] = PgNote.extend({
     init: 'I',
     desc: "Initials",
     iconClass: 'icm-alertpay',
     include: false,
     draw: false,   //?
     autoDisplayApplies: false
 });

 */


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/models/page/noteTypes/drawable/svg/signature.js
 ** module id = 296
 ** module chunks = 0
 **/